<template>
  <div>
    <v-card class="mb-10">
      <v-card-title class="primary white--text">{{
        $t(`dashboard.${name}`)
      }}</v-card-title>

      <template v-if="data && data.length > 0">
        <v-speed-dial
          v-model="fab"
          absolute=""
          top
          right
          direction="bottom"
          :open-on-hover="true"
          transition="scale"
        >
          <template v-slot:activator>
            <v-btn v-model="fab" color="blue darken-2" dark fab>
              <v-icon v-if="fab">mdi-close</v-icon>
              <v-icon v-else>mdi-dots-horizontal</v-icon>
            </v-btn>
          </template>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="dataToShow && dataToShow.url"
                fab
                @click="
                  downloadFile({ url: dataToShow.url, name: name, ext: 'pdf' })
                "
                color="blue"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="white">mdi-download</v-icon></v-btn
              >
            </template>
            <span>{{ $t("documents.download") }}</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                color="success"
                v-if="dataToShow && dataToShow.url"
                :href="dataToShow.url"
                target="_blank"
                v-bind="attrs"
                v-on="on"
                ><v-icon color="white">mdi-open-in-new</v-icon></v-btn
              >
            </template>
            <span>Open</span>
          </v-tooltip>

          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                :light="!$store.getters['auth/reliabilityWrite']"
                :dark="$store.getters['auth/reliabilityWrite']"
                :disabled="!$store.getters['auth/reliabilityWrite']"
                small
                color="#730D0B"
                @click="onDelete"
                v-bind="attrs"
                v-on="on"
                ><v-icon color="white">mdi-delete</v-icon></v-btn
              >
            </template>
            <span>{{ $t("documents.deleteDocument") }}</span>
          </v-tooltip>
        </v-speed-dial>
        <div class="relative">
          <v-btn
            class="page-controller"
            v-show="numPages > 1"
            v-bind="btnSize"
            color="primary"
            absolute
            bottom
            left
            fab
            :disabled="!navigationPage"
            @click="previousPage"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn
            class="page-counter"
            v-show="numPages > 0"
            color="primary"
            absolute
            v-bind="btnSize"
            bottom
            right
            fab
          >
            {{ currentPage }}/{{ numPages }}
          </v-btn>
          <v-btn
            class="page-controller"
            v-show="numPages > 1"
            color="primary"
            absolute
            v-bind="btnSize"
            bottom
            right
            fab
            :disabled="!navigationPage"
            @click="nextPage"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
          <pdf
            class="mb-5"
            :src="dataToShow"
            @num-pages="numPages = $event"
            @page-loaded="onPageLoaded($event)"
            :page="currentPage"
            ref="mypdf"
          ></pdf>
        </div>
        <v-divider class="mb-10"></v-divider>
        <v-container>
          <v-row v-if="data && data.length > 1">
            <v-col
              cols="12"
              :class="
                $vuetify.breakpoint.mdAndUp
                  ? 'px-4 d-flex justify-center'
                  : 'd-flex flex-column'
              "
            >
              <v-spacer></v-spacer>
              <v-btn
                :disabled="data && data.length - dataNegativeIndex <= 0"
                @click="previousVersion"
                color="primary"
                dark
                >{{ $t("documents.previousVersion") }}</v-btn
              >
              <v-spacer></v-spacer>
              <v-select
                :items="data && dataDateList"
                :label="$t('documents.selectVersion')"
                item-value="value"
                return-object
                @change="selectedData"
                dense
                :class="$vuetify.breakpoint.mdAndUp ? '' : 'my-4'"
                outlined
              >
                <template v-slot:selection="data">
                  {{ data.item.version }} - {{ data.item.date }}
                </template>
                <template v-slot:item="data">
                  {{ data.item.version }} - {{ data.item.date }}
                </template>
              </v-select>
              <v-spacer></v-spacer>

              <v-btn
                color="primary"
                dark
                :disabled="data && dataNegativeIndex <= 1"
                @click="nextVersion"
                >{{ $t("documents.nextVersion") }}</v-btn
              >
              <v-spacer></v-spacer>
            </v-col> </v-row
        ></v-container>

        <v-divider class="mb-10"></v-divider
      ></template>
      <v-file-input
        :disabled="!$store.getters['auth/reliabilityWrite']"
        class="my-10 mx-8"
        accept="application/pdf"
        ref="file"
        @change="uploadFiles"
        :loading="loading"
        :label="$t('dashboard.fileInput')"
        outlined
        dense
      ></v-file-input>
    </v-card>
  </div>
</template>
<script>
import downloadLogic from "@/mixins/downloadLogic";

import pdf from "vue-pdf";
import { storage } from "@/plugins/db";
import { mapState } from "vuex";
import moment from "moment";

export default {
  props: ["uid", "data", "name"],
  mixins: [downloadLogic],
  components: {
    pdf
  },
  data: () => ({
    i: 0,
    progressUpload: 0,
    uploadTask: "",
    uploading: false,
    uploadEnd: false,
    loading: false,
    downloadURL: "",
    success: false,
    fab: false,
    numPages: 0,
    currentPage: 1,
    dataNegativeIndex: 1,
    navigationPage: true
  }),
  methods: {
    async uploadFiles(file) {
      this.loading = true;
      let code = new Date()
        .toISOString()
        .split("-")
        .join("")
        .split(".")
        .join("")
        .split(":")
        .join("");

      try {
        await storage
          .ref(`${this.uid}/${this.name}/${this.name}${code}.pdf`)
          .put(file)
          .then(snapshot => {
            snapshot.ref.getDownloadURL().then(downloadURL => {
              this.$emit("done", downloadURL);
            });
          });
      } catch (error) {
        this.$dialog.notify.error(
          error.message
            ? error.message
            : "Error 403, por favor contacte al administrador",
          {
            position: "top-right",
            timeout: 5000
          }
        );
      }

      this.currentPage = 1;
      this.loading = false;
    },
    onDelete() {
      const itemToDelete = this.dataToShow;
      if (this.dataNegativeIndex !== 1) this.dataNegativeIndex -= 1;
      this.$emit("delete", itemToDelete);
    },
    onPageLoaded(current) {
      this.currentPage = current;
      this.navigationPage = true;
    },
    activePageNavigation() {
      this.navigationPage = true;
    },
    previousPage() {
      this.navigationPage = false;
      if (this.currentPage === 1) {
        this.currentPage = this.numPages;
      } else {
        this.currentPage -= 1;
      }
    },
    nextPage() {
      this.navigationPage = false;
      if (this.currentPage === this.numPages) {
        this.currentPage = 1;
      } else {
        this.currentPage += 1;
      }
    },
    previousVersion() {
      const limit = this.data?.length;
      if (limit - this.dataNegativeIndex <= 0) {
        return;
      } else {
        this.dataNegativeIndex += 1;
      }
      this.currentPage = 1;
    },
    nextVersion() {
      if (this.dataNegativeIndex <= 1) {
        return;
      } else {
        this.dataNegativeIndex -= 1;
      }
      this.currentPage = 1;
    },
    selectedData({ value }) {
      this.dataNegativeIndex = value;
      this.currentPage = 1;
    },
    FixingDate(value) {
      if (value) {
        moment.locale(this.user.language);
        return this.capitalizeTitles(
          moment.unix(value.seconds).format("MMMM D YYYY, h:mm:ss a")
        );
      } else {
        return null;
      }
    },
    capitalizeTitles(str) {
      if (str.length > 0) {
        const wordsArray = str.split(/(?=[A-Z])/);
        const capitalizedWords = wordsArray.map(word => {
          const capitalizedWord = `${word[0].toUpperCase()}${word.slice(1)}`;
          return capitalizedWord;
        });
        return capitalizedWords.join(" ");
      } else {
        return "";
      }
    }
  },
  computed: {
    ...mapState("auth", ["user"]),
    btnSize() {
      const size = { xs: "x-small", sm: "small", lg: "large", xl: "x-large" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
    dataToShow() {
      return this.data
        ? this.data[this.data.length - this.dataNegativeIndex]
        : undefined;
    },
    dataDateList() {
      if (!this.data) return [];
      const dateList = this.data.map((actualDate, index) => {
        return {
          date: this.FixingDate(actualDate.createdDate),
          version: actualDate.version ? actualDate.version : "--",
          value: this.data.length - index
        };
      });
      return dateList;
    }
  }
};
</script>

<style lang="sass">
.relative
  position: relative

.page-counter
  left: calc(50% - 28px)
  bottom: 1rem !important

.page-controller
  bottom: 50% !important
</style>
